  import React, { useContext, useEffect, useState } from "react";
  import { Form, message, Modal } from "antd";
  import { TechCardModal } from "src/enitities/Modal";
  import { TechCardsForm } from "src/enitities/Form";
  import { TechCardContext } from "src/shared/lib/hooks/context/getTechCardsContext";
  import { techCardsAPI } from "src/shared/api/techCardsAPI";

  export default function AddTechCard({ isOpen, setOpen, onSuccess, refreshData: refreshDataProp }) {
    const [changeData, setChangeData] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isSuccessfullySaved, setIsSuccessfullySaved] = useState(false);
    const { token, data, refreshData: refreshDataFromContext } = useContext(TechCardContext);
    const refreshData = refreshDataProp || refreshDataFromContext;
    const [parentOptions, setParentOptions] = useState([]);
    const [isConfirmVisible, setIsConfirmVisible] = useState(false);
    const [form] = Form.useForm();

    useEffect(() => {
      if (data && Array.isArray(data)) {
        const options = data.map((item) => ({
          value: item.id,
          label: `${item.code ? `${item.code} - ` : ""}${item.name}`,
        }));
        setParentOptions(options);
      }
    }, [data]);

    useEffect(() => {
      if (isOpen) {
        setChangeData(false);
        setIsSuccessfullySaved(false);
        form.resetFields();
      }
    }, [isOpen, form]);

    const prepareDataForAPI = (values) => {
      const preparedData = {
        name: values.name,
        description: values.description || "",
        code: values.code || "",
        card_type: values.card_type,
        auto_produce: values.auto_produce || false,
        parent: values.parent ? parseInt(values.parent) : null,
        items: (values.items || []).map(item => {
          const waste_from_heat_processing = parseFloat(item.waste_from_heat_processing || 0.01);
          if (waste_from_heat_processing <= 0) {
            throw new Error(`waste_from_heat_processing для позиции ${item.nomenclature_id} должно быть больше 0`);
          }
          const waste_from_cold_processing = parseFloat(item.waste_from_cold_processing || 0.01);
          if (waste_from_cold_processing <= 0) {
            throw new Error(`waste_from_cold_processing для позиции ${item.nomenclature_id} должно быть больше 0`);
          }
          return {
            nomenclature_id: parseInt(item.nomenclature_id),
            type_of_processing: item.type_of_processing,
            net_weight: parseFloat(item.net_weight || 0.1),
            waste_from_cold_processing,
            waste_from_heat_processing,
            quantity: parseInt(item.quantity || 1),
            gross_weight: parseFloat(item.gross_weight || 0.11),
            output: parseFloat(item.output || 0.1)
          };
        }).filter(item => item.nomenclature_id)
      };

      return preparedData;
    };

    const handleSubmitWrapper = async (values) => {
      setLoading(true);
      try {
        const preparedData = prepareDataForAPI(values);

        if (!preparedData.items.length) {
          message.error("Добавьте хотя бы одну позицию в техкарту");
          setLoading(false);
          return;
        }

        const result = await techCardsAPI.create(token)(preparedData);
        
        setIsSuccessfullySaved(true);
        setChangeData(false);
        form.resetFields();
        setOpen(false);
        
        if (refreshData) {
          await refreshData();
        }
        
        if (onSuccess) {
          onSuccess(result.data);
        }
        
        return result;
      } catch (error) {
        if (error.message.includes("waste_from_heat_processing")) {
          message.error(error.message);
        }
      } finally {
        setLoading(false);
      }
    };

    const handleCancel = () => {
      if (changeData && !isSuccessfullySaved) {
        setIsConfirmVisible(true);
        return;
      }

      setChangeData(false);
      setIsSuccessfullySaved(false);
      form.resetFields();
      setOpen(false);
    };

    const handleConfirmClose = () => {
      setIsConfirmVisible(false);
      setChangeData(false);
      setIsSuccessfullySaved(false);
      form.resetFields();
      setOpen(false);
    };

    return (
      <>
      <TechCardModal
        title="Добавить тех. карту"
        width={1800}
        isOpen={isOpen}
        setOpen={setOpen}
        formContext={form}
        handleSubmit={handleSubmitWrapper}
        changeData={changeData}
        setChangeData={setChangeData}
        loading={loading}
        onCancel={handleCancel}
        okText="Создать"
        cancelText="Отмена"
        destroyOnClose
        maskClosable={false}
        isSuccessfullySaved={isSuccessfullySaved}
      >
        <TechCardsForm
          formContext={form}
          parent={parentOptions}
          api={`https://${process.env.REACT_APP_APP_URL}/api/v1/`}
          token={token}
          setChangeData={(value) => {
            if (!isSuccessfullySaved) {
              setChangeData(value);
            }
          }}
        />
      </TechCardModal>

        <Modal
          open={isConfirmVisible}
          title="Вы уверены, что хотите закрыть?"
          onOk={handleConfirmClose}
          onCancel={() => setIsConfirmVisible(false)}
          okText="Да, закрыть"
          cancelText="Отмена"
          centered
        >
          <p>Вы не сохранили изменения в техкарте. Закрыть окно без сохранения?</p>
        </Modal>
      </>
    );
  }